<style lang="scss" scoped>
.head {
  margin-top: 50px;
}
h1 {
  color: black !important;
}
</style>

<template>
  <DegreeBar v-if="feedback" />
  <div class="row mt-5" v-if="h1 || h2">
    <div class="col-12">
      <h1 v-if="h1">{{ h1 }}</h1>
      <h2 v-if="h2">{{ h2 }}</h2>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import DegreeBar from '@/components/DegreeBar.vue';

export default defineComponent({
  components: {
    DegreeBar,
  },
  props: {
    h1: { type: String },
    h2: { type: String },
    feedback: { type: Boolean, default: true },
  },
  setup() {
    const store = useStore();

    const showbuttons = computed(() => {
      if (store.getters.hasPerm('overview.manager')) {
        return true;
      }

      return false;
    });

    return {
      showbuttons,
    };
  },
});
</script>
